import styled from 'styled-components';
import { ListboxOptionMixin } from '../../mixins/components/ListboxOptionMixin';
export var StyledListboxOption = /*#__PURE__*/styled.li.withConfig({
  displayName: "StyledListboxOption",
  componentId: "c11n-8-107-0__sc-7hr6e0-0"
})(["", ""], ListboxOptionMixin);